export default {
	title: 'Today\'s Summary',
	sales: 'Sales',
	returns: 'Returns',
	customer: 'Customer',
	quantity: 'Quantity',
	'package-price': 'Package price',
	'total-price': 'Total price',
	time: 'Time',
	'total-amount': 'Total amount',
	'grand-total': 'Total',
	'unknown-material': 'Unknown material',
	'unknown-customer': 'Unknown customer',
	'no-data': 'No transactions for this day',
}
